import {
    type ApiResult,
    type BaseParams,
    type CreateEmojiGroup,
    type DisplayEmojiGroupResponse,
    type EmojiGroupCheckResponse,
    type EmojiId,
    links,
    type PaginatedResult,
    type PagingParams,
    type PostParams,
    Request,
    type ResourceId,
    type UpdateEmojiGroup,
} from '@app/client';
import { apiReturnPaginatedResults, apiReturnResults } from '@app/client/apiFactory/apiReturn';
import { check } from '@app/client/resources/emojis/emojis';

export async function getCollection(
    params: BaseParams<PagingParams>,
): Promise<ApiResult<PaginatedResult<DisplayEmojiGroupResponse>>> {
    return Request.getRequest<PaginatedResult<DisplayEmojiGroupResponse>>({
        ...params,
        target: links.admin().groups().collection(),
    });
}

export async function create(
    params: BaseParams & PostParams<CreateEmojiGroup>,
): Promise<ApiResult<DisplayEmojiGroupResponse[]>> {
    return Request.postRequest<DisplayEmojiGroupResponse[]>({
        ...params,
        settings: {
            ...params.settings,
        },
        target: links.admin().groups().collection(),
    });
}

export async function update(
    params: BaseParams & PostParams<UpdateEmojiGroup> & { id: ResourceId },
): Promise<ApiResult<DisplayEmojiGroupResponse[]>> {
    return Request.patchRequest<DisplayEmojiGroupResponse[]>({
        ...params,
        settings: {
            ...params.settings,
        },
        target: links.admin().groups().single(params.id),
    });
}

export async function remove(params: BaseParams & { id: ResourceId }): Promise<ApiResult<DisplayEmojiGroupResponse>> {
    return Request.deleteRequest<DisplayEmojiGroupResponse>({
        ...params,
        settings: {
            ...params.settings,
        },
        target: links.admin().groups().single(params.id),
    });
}

export const callGetEmojiGroups = (params: BaseParams<PagingParams>) =>
    apiReturnPaginatedResults<DisplayEmojiGroupResponse>(getCollection, params);
export const callDeleteEmojiGroup = (params: BaseParams & { id: ResourceId }) =>
    apiReturnResults<DisplayEmojiGroupResponse>(remove, params);

export const callUpdateEmojiGroup = (params: BaseParams & PostParams<UpdateEmojiGroup> & { id: ResourceId }) =>
    apiReturnResults<DisplayEmojiGroupResponse>(update, params);

export const callCreateEmojiGroup = (params: BaseParams & PostParams<CreateEmojiGroup>) =>
    apiReturnResults<DisplayEmojiGroupResponse>(create, params);

export const callCheckEmoji = (params: BaseParams & { eid: EmojiId }) =>
    apiReturnResults<EmojiGroupCheckResponse>(check, params);
